export const aboutPhotos = [
  {
    id: "guitar",
    title: "Making music",
    label: "Away from the keyboard",
    caption: "Making time for music.",
    alt: "Darren Hayden smiling while holding an acoustic guitar.",
    src: "/images/about/darren-guitar-1200.webp",
    srcSet: "/images/about/darren-guitar-480.webp 480w, /images/about/darren-guitar-800.webp 800w, /images/about/darren-guitar-1200.webp 1200w",
    thumbnail: "/images/about/darren-guitar-160.webp",
    width: 3330,
    height: 4844,
  },
  {
    id: "running",
    title: "On the track",
    label: "One more lap",
    caption: "Collegiate distance running.",
    alt: "Darren Hayden running on an indoor track in his red collegiate racing uniform.",
    src: "/images/about/darren-running-1182.webp",
    srcSet: "/images/about/darren-running-480.webp 480w, /images/about/darren-running-800.webp 800w, /images/about/darren-running-1182.webp 1182w",
    thumbnail: "/images/about/darren-running-160.webp",
    width: 1182,
    height: 1600,
  },
] as const;
